import React, {Component} from 'react';
import PackageProductItem from "./PackageProductItem";

class TransactionItem extends Component {

	render() {

		const { name, description, type, packageProducts, id } = this.props;

		let packageProductList = null;

		if ( packageProducts ) {
			packageProductList = packageProducts.map( ( product, id ) => {
				return <PackageProductItem
					key={ id }
					name={ product.name }
				/>;
			} );
		} else {
			packageProductList = null;
		}

		return (
			<div className="transaction-item row">
				<div className="col-xs-3 col-sm-2 item-label">
					<strong>{ type }:</strong>
				</div>
				<div className="col-xs-5 col-sm-6">
					<span className="item-product-name">{ name }</span>
				</div>
				{ packageProductList ?
					<div className="col-xs-4 col-sm-4">
						<ul className="buttons-right">
							<li>
								<button className="btn btn-primary btn-block" data-toggle="collapse" data-target={ '#package-product-list-' + id } aria-expanded="false" aria-controls="collapseExample">
									<span className="label">See Products</span>
									<span className="icon"><i className="fa fa-angle-down fa-right"></i></span>
								</button>
							</li>
						</ul>
					</div>
					: ''
				}
				{ packageProductList ?
					<div className="col-xs-12">
						<div className="row">
							<div className="col-xs-9 col-xs-offset-3 col-sm-10 col-sm-offset-2">
								<ul id={'package-product-list-' + id } className="item-package-product-list collapse"> { packageProductList } </ul>
							</div>
						</div>
					</div>
					: ''
				}
			</div>
		)
	}
}
export default TransactionItem;


// WEBPACK FOOTER //
// src/client/components/site/features/account/transactionHistory/TransactionItem.js